import { isIos } from "./mobile";

let initialized = false;

export function init() {
	// only initialize once else the context menu could be triggered multiple times.
	if (initialized) {
		return;
	}

	initialized = true;

	initializeContextMenuEmulation();
}

function initializeContextMenuEmulation(): void {
	// Android has context menu out of the box
	if (!isIos()) {
		return;
	}

	let downTimer: SetTimeoutHandle;

	window.addEventListener(
		"touchstart",
		(e: TouchEvent): void => {
			const _event = new PointerEvent(
				"contextmenu",
				{
					bubbles: true,
					// getting the position of the touch event and inject them in the
					// context menu event else it does not contain position and it will
					// outline bottom left.
					clientX: e.touches[0].clientX,
					clientY: e.touches[0].clientY
				}
			);

			downTimer = setTimeout(
				(): void => {
					// trigger the context menu on the object where the touch occured
					e.target
						?.dispatchEvent(_event);
				},
				600
			);
		}
	);

	window.addEventListener(
		"touchmove",
		(): void => {
			//clear timeout because of swipe/move on scrollbar
			clearTimeout(downTimer);
		}
	);

	window.addEventListener(
		"touchend",
		(): void => {
			// clear timeout else it would cast a context menu on just a single click
			clearTimeout(downTimer);
		}
	);
}
